import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UserOrganizationClient, UserOrganizationView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class UserOrganizationService {
    constructor(private readonly client: UserOrganizationClient) {}

    async userOrganizationGetForCurrentUser(): Promise<UserOrganizationView[]> {
        return await lastValueFrom(this.client.userOrganizationGetForCurrentUser());
    }
}
